document.addEventListener('DOMContentLoaded', function () {
  var selectedTitle = document.getElementById('fh-selected-title');
  if (selectedTitle) {
    selectedTitle.style.setProperty('color', '#fff', 'important');
    selectedTitle.style.setProperty('opacity', '1', 'important');
  }

  var storyMedia = document.querySelector('.fh-home .fh-story-img');
  if (storyMedia) {
    var existingVideo = storyMedia.querySelector('video');
    if (existingVideo) {
      var image = document.createElement('img');
      image.src = 'https://cdn.shopify.com/s/files/1/0682/1271/9765/files/fahari-crafted-purpose.jpg?v=1785524460';
      image.alt = 'Fahari bracelet being crafted by hand';
      image.loading = 'lazy';
      image.decoding = 'async';
      storyMedia.innerHTML = '';
      storyMedia.appendChild(image);

      var label = document.createElement('span');
      label.textContent = 'Crafted with purpose';
      storyMedia.appendChild(label);
    }
  }

  function runProductReviewPass() {
    var isProductPage = /\/products\//.test(window.location.pathname) || document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!isProductPage) return;

    document.documentElement.classList.add('fh-product-enhanced');

    function cleanKenyaText(root) {
      if (!root) return;
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        var next = node.nodeValue
          .replace(/Handmade in Kenya\s*•\s*/gi, '')
          .replace(/Handmade in Kenya\s*/gi, '');
        if (next !== node.nodeValue) node.nodeValue = next;
      });
    }

    function findProductTitle() {
      var selectors = [
        '.product__title h1',
        '.productView-title',
        '.product-title',
        'h1.product-single__title',
        'main h1'
      ];
      for (var i = 0; i < selectors.length; i += 1) {
        var el = document.querySelector(selectors[i]);
        if (el) return el;
      }
      return null;
    }

    function removeShopPayBlockingCheckbox() {
      var paymentButton = document.querySelector('.shopify-payment-button, [data-shopify="payment-button"], shopify-accelerated-checkout');
      if (!paymentButton) return;

      var form = document.querySelector('form[action*="/cart/add"]');
      var scope = form && form.parentElement ? form.parentElement : document.body;
      var checkboxes = Array.prototype.slice.call(scope.querySelectorAll('input[type="checkbox"]'));

      checkboxes.forEach(function (checkbox) {
        var rect = checkbox.getBoundingClientRect();
        var payRect = paymentButton.getBoundingClientRect();
        var isNearPaymentButton = rect.top < payRect.top && payRect.top - rect.top < 180;
        var label = checkbox.closest('label');
        var wrapper = checkbox.closest('.product-form__input, .form-field, .line-item-property__field, .field, .checkbox, .halo-product-checkbox') || label || checkbox.parentElement;
        var wrapperText = wrapper ? (wrapper.textContent || '').replace(/\s+/g, ' ').trim() : '';
        var looksLikeEmptyBlocker = isNearPaymentButton && (!wrapperText || wrapperText.length < 6 || rect.width <= 24);

        if (looksLikeEmptyBlocker) {
          checkbox.checked = true;
          checkbox.setAttribute('checked', 'checked');
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          checkbox.classList.add('fh-shop-pay-checkbox-hidden');
          checkbox.style.setProperty('display', 'none', 'important');
          checkbox.style.setProperty('visibility', 'hidden', 'important');
          checkbox.style.setProperty('pointer-events', 'none', 'important');
          if (wrapper) {
            wrapper.classList.add('fh-shop-pay-checkbox-hidden');
            wrapper.style.setProperty('display', 'none', 'important');
            wrapper.style.setProperty('visibility', 'hidden', 'important');
            wrapper.style.setProperty('pointer-events', 'none', 'important');
          }
        }
      });
    }

    function alignProductTrustBadges() {
      var labels = [/Free Shipping/i, /FIRSTORDER/i, /Easy Returns/i];
      var matches = [];

      Array.prototype.slice.call(document.querySelectorAll('body *')).forEach(function (el) {
        if (el.children.length > 8) return;
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!text) return;
        labels.forEach(function (pattern, index) {
          if (pattern.test(text) && !matches[index]) matches[index] = el;
        });
      });

      if (matches.filter(Boolean).length < 2) return;

      matches.forEach(function (match) {
        var item = match;
        for (var i = 0; i < 4 && item && item.parentElement; i += 1) {
          var siblings = Array.prototype.slice.call(item.parentElement.children);
          if (siblings.length >= 2 && siblings.length <= 6) break;
          item = item.parentElement;
        }
        if (item) item.classList.add('fh-product-trust-item');
      });

      var container = matches[0];
      while (container && container.parentElement) {
        var containerText = (container.textContent || '').replace(/\s+/g, ' ');
        if (/Free Shipping/i.test(containerText) && /FIRSTORDER/i.test(containerText) && /Easy Returns/i.test(containerText)) {
          container.classList.add('fh-product-trust-row');
          break;
        }
        container = container.parentElement;
      }
    }

    function styleProductRecommendationsCopy() {
      var headingText = 'You Might Also Like';
      var copyText = 'Explore similar handmade flag bracelets from around the world.';

      Array.prototype.slice.call(document.querySelectorAll('body *')).forEach(function (el) {
        if (el.children.length > 6) return;
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim();

        if (text === headingText) {
          el.classList.add('fh-product-reco-heading');
          var parent = el.parentElement;
          if (parent) parent.classList.add('fh-product-reco-block');
        }

        if (text === copyText) {
          el.classList.add('fh-product-reco-copy');
          var copyParent = el.parentElement;
          if (copyParent) copyParent.classList.add('fh-product-reco-block');
        }
      });
    }

    function enhanceProductPage() {
      document.querySelectorAll('.fh-product-review-proof').forEach(function (node) { node.remove(); });
      cleanKenyaText(document.body);
      removeShopPayBlockingCheckbox();
      alignProductTrustBadges();
      styleProductRecommendationsCopy();

      var title = findProductTitle();
      
    }

    enhanceProductPage();
    var productObserver = new MutationObserver(function () {
      window.clearTimeout(window.__fhProductEnhanceTimer);
      window.__fhProductEnhanceTimer = window.setTimeout(enhanceProductPage, 120);
    });
    productObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
    window.setTimeout(function () { productObserver.disconnect(); }, 6000);
  }

  runProductReviewPass();

  var grid = document.getElementById('fh-bundle-products');
  var search = document.getElementById('fh-bundle-q');

  if (!grid) return;

  var applying = false;
  var maxVisibleCards = 10;

  function isAnkletCard(card) {
    return /anklet/i.test(card.textContent || '');
  }

  function limitBundleCards() {
    if (applying) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.fh-bundle-card'));
    var braceletCards = cards.filter(function (card) {
      if (isAnkletCard(card)) {
        card.remove();
        return false;
      }
      return true;
    });

    if (braceletCards.length <= maxVisibleCards) return;

    applying = true;

    var hasSearch = search && search.value.trim().length > 0;
    if (!hasSearch) {
      braceletCards.forEach(function (card) {
        if (!card.dataset.fhRandomOrder) {
          card.dataset.fhRandomOrder = String(Math.random());
        }
      });
      braceletCards.sort(function (a, b) {
        return Number(a.dataset.fhRandomOrder) - Number(b.dataset.fhRandomOrder);
      });
    }

    braceletCards.forEach(function (card, index) {
      if (index < maxVisibleCards) {
        card.style.display = '';
        grid.appendChild(card);
      } else {
        card.remove();
      }
    });

    applying = false;
  }

  var observer = new MutationObserver(limitBundleCards);
  observer.observe(grid, { childList: true, subtree: true });

  if (search) {
    search.addEventListener('input', function () {
      window.setTimeout(limitBundleCards, 260);
    });
  }

  window.setTimeout(limitBundleCards, 0);
});
